import { Injectable, Inject } from '@angular/core';

export class PolicyPaymentDO {

	public id: Number = null;

	public paymentMethodCd: String = null;

	public paymentFrequencyCd: String = null;

	public accountNum: String = null;

	public accountHolderName: String = null;

	public clientRefGuid: any = null;

	public bankName: any = null;

	public bankBranchName: any = null;

	public branchIdNum1: any = null;

	public branchIdNum2: any = null;
}

export class ClaimPaymentDO {
	public paymentMethodCd: String = null

	public paymentFrequencyCd: String = null

	public accountNum: String = null

	public accountHolderName: String = null

	public bankName: String = null

	public bankBranchName: String = null

	public paymentAmt: any = null

	public paymentSplitPrct: any = null

	public statusCd: any = null


	//IFSC
	public branchIdNum1: String = null

	//MICR
	public branchIdNum2: String = null

	public clientRefGuid: String = null
}